import { Text } from '@thanx/uikit/text'
import React from 'react'
import { useStyletron } from 'styletron-react'

type Props = {
  text: string
  iconClass: string
  iconColor: string
}

// One do/don't bullet row, shared by StanceCard and GenerositySliderBody (R12 —
// extracted to retire the verbatim duplicate). The leading icon is decorative —
// the bullet text already conveys "do" vs "don't" — so it's aria-hidden.
const StanceBulletRow = ({ text, iconClass, iconColor }: Props) => {
  const [css] = useStyletron()
  return (
    <div className={`d-flex align-items-start ${css({ gap: '8px' })}`}>
      <i
        className={`fa ${iconClass} ${css({
          fontSize: '14px',
          color: iconColor,
          flexShrink: 0,
          marginTop: '3px',
        })}`}
        aria-hidden="true"
      />
      <Text.BodyText4 color="grey70">{text}</Text.BodyText4>
    </div>
  )
}

export default StanceBulletRow
